import { render, staticRenderFns } from "./Script.vue?vue&type=template&id=18218cc4"
import script from "./Script.vue?vue&type=script&lang=js"
export * from "./Script.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports